import { FormGroup} from "reactstrap";
import Dropzone from 'react-dropzone'

export default function ImageUploader(props) {

  return (
      <FormGroup>
            <Dropzone onDrop={acceptedFiles => {props.handleChangeImg(acceptedFiles[0])}}>
                      {({getRootProps, getInputProps}) => (
                        <section>
                          <div  className='dropZoneCont' {...getRootProps()}>
                            <input accept="image/*" {...getInputProps()} />
                            <p>{!props.titleImg ? 'Arrastre o presione aqui para elegir una imagen' : props.titleImg.name}</p>
                          </div>
                        </section>
                      )}
                    </Dropzone>
          </FormGroup>

  );
}